import {
	Button,
	Divider,
	List,
	ListItemButton,
	ListItemIcon,
	Popover,
	Typography,
} from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import ListAltIcon from '@mui/icons-material/ListAlt';
import CustomerIcon from '@mui/icons-material/People';
import {
	MarkAllNotificationsAsRead,
	MarkNotificationAsRead,
} from '../../services/api/Notifications';

export default function Notifications({
	notifications,
	anchorEl,
	notificationOpen,
	handleNotificationClose,
	fetchNotifications,
	notificationId,
}: any) {
	const navigate = useNavigate();

	// Calculate unread count
	const unreadCount = notifications?.filter((n: any) => !n.isRead)?.length;

	const markAsRead = async (type: string, id: number) => {
		console.log('Marking as read:>>>>>>>>>>>>>>>>>>>>>>>>>>>', type, id);
		try {
			await MarkNotificationAsRead(type, id.toString());
			fetchNotifications();
		} catch (error) {
			console.error('Error marking notification as read:', error);
		}
	};

	const markAllAsRead = async () => {
		try {
			await MarkAllNotificationsAsRead();
			fetchNotifications();
		} catch (error) {
			console.error('Error marking all notifications as read:', error);
		}
	};

	const handleNotificationItemClick = (type: string, id: number) => {
		markAsRead(type, id);
		handleNotificationClose();
		if (type === 'quotations') {
			navigate(`/quotation/${id}`);
		} else if (type === 'contact_us') {
			navigate('/enquiries');
		} else if (type === 'book_us') {
			navigate('/booking');
		}
	};

	return (
		<Popover
			id={notificationId}
			open={notificationOpen}
			anchorEl={anchorEl}
			onClose={handleNotificationClose}
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'right',
			}}
			transformOrigin={{
				vertical: 'top',
				horizontal: 'right',
			}}
			sx={{
				mt: 1,
				// maxHeight: '60vh',
				// overflowY: 'auto', // Changed from 'hideden' to 'auto'
			}}
		>
			<Box sx={{ p: 2, width: 400 }}>
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
						mb: 2,
					}}
				>
					<Typography variant="h6">Notifications</Typography>
					<Button
						size="small"
						onClick={(e) => {
							e.stopPropagation();
							markAllAsRead();
						}}
						disabled={unreadCount === 0}
					>
						Mark all as read
					</Button>
				</Box>
				<Divider />
				{notifications?.length > 0 ? (
					<List>
						{notifications?.map((notification: any) => (
							<React.Fragment key={notification.id}>
								<ListItemButton
									onClick={() =>
										handleNotificationItemClick(
											notification.type,
											notification.id
										)
									}
									sx={{
										backgroundColor: notification.isRead
											? 'inherit'
											: 'action.hover',
										'&:hover': {
											backgroundColor: 'action.selected',
										},
										alignItems: 'flex-start',
										py: 2,
									}}
								>
									<ListItemIcon sx={{ minWidth: 40, mt: 1 }}>
										{notification.type === 'contact_us' && (
											<MailOutlineIcon
												color={notification.isRead ? 'disabled' : 'primary'}
											/>
										)}
										{notification.type === 'quotations' && (
											<ListAltIcon
												color={notification.isRead ? 'disabled' : 'primary'}
											/>
										)}
										{notification.type === 'book_us' && (
											<CustomerIcon
												color={notification.isRead ? 'disabled' : 'primary'}
											/>
										)}
									</ListItemIcon>
									<Box sx={{ flexGrow: 1 }}>
										<Box
											sx={{
												display: 'flex',
												justifyContent: 'space-between',
											}}
										>
											<Typography
												variant="subtitle1"
												sx={{
													fontWeight: notification.isRead
														? 'normal'
														: 'medium',
													color: notification.isRead
														? 'text.secondary'
														: 'text.primary',
												}}
											>
												{notification.type === 'contact_us' &&
													'New Enquiry'}
												{notification.type === 'quotations' &&
													'New Quotation'}
												{notification.type === 'book_us' && 'New Booking'}
											</Typography>
											<Typography variant="caption" color="text.secondary">
												{new Date(
													notification.createdAt
												).toLocaleDateString()}
											</Typography>
										</Box>

										{/* Notification Content based on type */}
										{notification.type === 'contact_us' && (
											<>
												<Typography variant="body2">
													From: {notification.name} ({notification.email})
												</Typography>
												<Typography variant="body2">
													Mobile: {notification.mobile}
												</Typography>
												<Typography variant="body2">
													Message: {notification.message}
												</Typography>
												{/* {notification.followupStatus && (
													<Typography variant="body2">
														Status: {notification.followupStatus}
													</Typography>
												)} */}
											</>
										)}

										{notification.type === 'quotations' && (
											<>
												<Typography variant="body2">
													Customer: {notification.name} (
													{notification.email})
												</Typography>
												<Typography variant="body2">
													Event Date:{' '}
													{notification.functionDate &&
														new Date(
															notification.functionDate
														).toLocaleDateString()}
												</Typography>
												<Typography variant="body2">
													Location: {notification.location}
												</Typography>
												<Typography variant="body2">
													Total Price: ₹
													{notification.totalPrice?.toLocaleString()}
												</Typography>
												{/* <Typography variant="body2">
													Status: {notification.status}
												</Typography> */}
												<Typography variant="body2">
													Quotation ID: {notification.quotationId}
												</Typography>
											</>
										)}

										{notification.type === 'book_us' && (
											<>
												<Typography variant="body2">
													Customer: {notification.name} (
													{notification.email})
												</Typography>
												<Typography variant="body2">
													Event Date:{' '}
													{notification.eventDate &&
														new Date(
															notification.eventDate
														).toLocaleDateString()}
												</Typography>
												<Typography variant="body2">
													Address: {notification.address}
												</Typography>
												<Typography variant="body2">
													No. of People: {notification.noOfPeoples}
												</Typography>
												<Typography variant="body2">
													Description: {notification.description}
												</Typography>
												<Typography variant="body2">
													Booking ID: {notification.bookingId}
												</Typography>
												{/* <Typography variant="body2">
													Status: {notification.status}
												</Typography> */}
											</>
										)}
									</Box>
								</ListItemButton>
								<Divider />
							</React.Fragment>
						))}
					</List>
				) : (
					<Typography variant="body2" sx={{ p: 2, textAlign: 'center' }}>
						No notifications available
					</Typography>
				)}
			</Box>
		</Popover>
	);
}
